module.exports = __webpack_public_path__ + "media/images/github-copilot-plan_credit-brands-1e7abe8ac3e8eb053175b2102671b863.png";